import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { Course } from '@mc/api'
import { useBucket } from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { trackExperimentViewed } from '@mc/track-event'
import { CM_INNOVATIVE_SWING_FLAG_NAME } from '../constants'
import { useGetCmInnovativeSwingClasses } from './useCMInnovativeSwingData'

// Matches /classes/[slug] but not /classes/[slug]/chapters
const isClassPage = (pathname: string) => /^\/classes\/[^/]+$/.test(pathname)

export const useCMInnovativeSwingExp = () => {
  const router = useRouter()
  const bucket = useBucket(CM_INNOVATIVE_SWING_FLAG_NAME)
  const classes = useGetCmInnovativeSwingClasses()
  const { course } = useStaticData<{ course: Course }>()
  const isCmPage = isClassPage(router.pathname)

  let classInExperiment = false

  if (course) {
    classInExperiment = classes?.includes(course.slug) ?? false
  }

  const experimentCriteria = isCmPage && classInExperiment

  return {
    isVariant1: bucket === 'variant_1' && experimentCriteria,
    isVariant2: bucket === 'variant_2' && experimentCriteria,
    isOn: !!bucket && experimentCriteria,
  }
}

export const useTrackCMInnovativeSwingExp = () => {
  const { isOn } = useCMInnovativeSwingExp()

  useEffect(() => {
    if (isOn) {
      trackExperimentViewed(CM_INNOVATIVE_SWING_FLAG_NAME)
    }
  }, [isOn])
}
